import { ICommentTableEntry } from '../CommentsTable';
import { ICommentResponse } from '../../../../types/order/comment/IComment';
import { commentTypeColor, eCommentType, prettyCommentsType } from '../../../../types/order/comment/eCommentType';

export const convertIVendorCommentResponseToICommentTableEntry = ({
  id,
  createdAt,
  content,
  type,
  author,
}: ICommentResponse): ICommentTableEntry => {
  return {
    id: id,
    datePosted: createdAt,
    commentTypeDisplay: prettyCommentsType[type || eCommentType.titleSearch],
    commentTypeColor: commentTypeColor[type || eCommentType.titleSearch],
    postedBy: author.fullName,
    content,
  };
};
